<template>
  <section class="hero is-default is-bold">
    <div class="hero-body">
      <div class="container">
        <div class="columns">
          <div class="column is-8 is-offset-2">
            <food-form
              v-if="!foodSubmitted"
              :isSurvey="true"
              :startStep="1"
              :totalStep="1"
              :year="year"
              v-model="food"
              @submit="validateFood"
              :isSimulation="true"
            />
            <template v-else>
              <div class="columns">
                <div class="column">
                  <b-notification
                    :has-icon="true"
                    :icon="'cutlery'"
                    :closable="false"
                  >
                    <strong
                      >{{ $t('viewFoodsSimulator.summary-7') }} ({{
                        food.nMeals
                      }}
                      {{ $t('meals') }})</strong
                    >
                    <br />
                    {{ foodSummary }}
                  </b-notification>
                </div>
                <div style="display: flex" class="column is-4">
                  <b-notification
                    style="
                      flex: 1;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                    :closable="false"
                  >
                    <div class="level-item has-text-centered">
                      <div>
                        <p class="heading has-text-carbone">
                          <b-icon icon="cutlery" />
                          {{ $t('viewFoodsSimulator.annual-emissions') }}
                        </p>
                        <div class="title is-size-4 has-text-carbone">
                          <p>
                            {{
                              (Math.round(intensity.intensity * 100) / 100)
                                | splitNumber
                            }}
                            &plusmn;
                            {{
                              (Math.round(intensity.uncertainty * 100) / 100)
                                | splitNumber
                            }}
                            <span class="is-size-6">{{ $t('kg.co2e') }}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </b-notification>
                </div>
              </div>
              <b-carousel
                :autoplay="false"
                indicator-style="is-lines"
                :indicator-inside="true"
              >
                <b-carousel-item>
                  <ghgi-information-fr
                    :isSimulation="true"
                    :simulations="simulations"
                  />
                </b-carousel-item>
                <b-carousel-item>
                  <meals-emission-factors />
                </b-carousel-item>
                <b-carousel-item>
                  <foods-emission-factors />
                </b-carousel-item>
              </b-carousel>
              <br />
              <div class="columns">
                <div class="column">
                  <button class="button is-fullwidth" @click="resetSimulations">
                    <span class="icon is-small"
                      ><i class="fa fa-refresh"></i
                    ></span>
                    <span>{{ $t('viewFoodsSimulator.reset') }}</span>
                  </button>
                </div>
                <div class="column">
                  <button
                    class="button is-fullwidth is-primary"
                    @click="newSimulation"
                  >
                    <span class="icon is-small"
                      ><i class="fa fa-plus"></i
                    ></span>
                    <span>{{ $t('viewFoodsSimulator.new-simulation') }}</span>
                  </button>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Food from '@/models/carbon/Food.js'
import { useCoreStore } from '@/stores/core.js'

export default {
  name: 'CommutesSimulation',
  components: {
    'food-form': () => import('@/components/carbon/forms/foods/Form.vue'),
    'foods-emission-factors': () =>
      import('@/components/graphics/FoodsEmissionFactors.vue'),
    'meals-emission-factors': () =>
      import('@/components/graphics/MealsEmissionFactors.vue'),
    'ghgi-information-fr': () =>
      import('@/components/graphics/GHGIInformationFR.vue')
  },
  data () {
    return {
      error: '',
      simulations: [],
      foodSubmitted: false,
      year: new Date().getFullYear(),
      food: this.getInitFood()
    }
  },
  setup () {
    const coreStore = useCoreStore()
    return { coreStore }
  },
  computed: {
    options: function () {
      return { NUMBER_OF_WORKED_WEEKS: { default: 52 * 2 } }
    },
    intensity: function () {
      let food = Food.createFromObj(this.food)
      return food.getCarbonIntensity(this.options, this.year)
    },
    foodSummary () {
      let label = ''
      for (let meal of this.food.meals) {
        label += meal.amount + ' ' + this.$t(meal.type) + ', '
      }
      return label.slice(0, -2)
    }
  },
  methods: {
    validateFood () {
      this.food = Food.createFromObj(this.food)
      this.food.clean()
      this.simulations.push({
        food: this.food,
        year: this.year
      })
      this.foodSubmitted = true
      window.scrollTo(0, 0)
    },
    getInitFood () {
      let food = Food.createEmpty()
      food.nWorkingDay = 7
      return food
    },
    resetSimulations () {
      this.simulations = []
      this.food = this.getInitFood()
      this.foodSubmitted = false
    },
    newSimulation () {
      this.food = this.getInitFood()
      this.year = new Date().getFullYear()
      this.foodSubmitted = false
      window.scrollTo(0, 0)
    }
  },
  mounted () {
    this.food = this.getInitFood()
    this.year = new Date().getFullYear()
    this.foodSubmitted = false
    window.scrollTo(0, 0)
  }
}
</script>

<style>
.has-text-carbone {
  color: #208dbc !important;
}
</style>
